export default "__VITE_ASSET__Cj8GMR6S__"